import { BoxMenuThemeSizeConfig } from './types';

const large: BoxMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default large;
